import { GoogleAnalyticsScript } from './GoogleAnalyticsScript';
import { GA_ID_BRANDSITE } from './constants';

// 웹뷰가 기반이 아닌 웹은 이걸로 수집.
export const GoogleAnalyticsBrandsiteScript = () => {
  return <>
    <GoogleAnalyticsScript gaId={GA_ID_BRANDSITE} />
  </>;
};